import styled from 'styled-components';

import {
    formControlColors,
    inContainerFormControlColors,
} from '../../../shared-components/variables/componentColors/formControlVariableColors';
import {FixedSidebar} from '../../custom-feature/fixed-sidebar/FixedSidebar';
import {FormGroup} from '../../form-v2/form-containers/FormGroup';
import {colorTheme} from '../../mixin/colorTheme';
import {CardActionsHoverWrapper, CardHeader, conditionCardSize} from './CardSections';

/**
 * @type {import("styled-components").StyledComponent<"div", AnyIfEmpty<DefaultTheme>, {
 *     size?: "sm";
 * }, never>}
 */
export const CardWrapper = styled.div`
    background: var(--container-background-color-100);
    border-radius: var(--card-border-radius);
    box-shadow: var(--container-shadow-color-100);
    border: 1px solid var(--container-border-color-500);
    color: var(--default-text-color);
    margin-bottom: var(--space-sm);
    position: relative;
    ${conditionCardSize};
    ${inContainerFormControlColors};

    // ==== --------------------------------- ==== ///
    // ==== -- Card body with inner Header -- ==== ///
    // ==== --------------------------------- ==== ///

    ${CardHeader} {
        border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
        margin: calc(0px - var(--card-padding)) calc(0px - var(--card-padding)) var(--card-padding);
    }

    &:has(${CardActionsHoverWrapper.toString()}) {
        &:hover {
            ${CardHeader} {
                background: var(--container-background-hover-color-500);
            }

            background: var(--container-background-hover-color-300);

            ${CardActionsHoverWrapper} {
                opacity: 1;
                pointer-events: fill;
                transition: 0.6s;
                top: 0;
                right: 0;
            }
        }
    }

    ${FixedSidebar} & {
        background: var(--container-background-color-200);
        box-shadow: var(--container-shadow-color-200);

        ${formControlColors()};
        ${colorTheme({
            '--card-sidebar-input-background-color': {dark: 'var(--black-04)', light: 'var(--white-00)'},
            '--card-sidebar-input-border-color': {dark: 'var(--black-02)', light: 'var(--gray-02)'},
        })};
        --form-control-background-color: var(--card-sidebar-input-background-color);
        --form-control-border-color: var(--card-sidebar-input-border-color);
        --form-word-fix-border-color: var(--card-sidebar-input-border-color);
    }

    ${FormGroup} {
        --form-box-background-color: var(--container-background-color-200);
        --form-box-border-color: var(--container-border-color-200);
        --form-labeled-affix-background-color: var(--container-background-color-500);
        --form-labeled-affix-border-color: var(--container-border-color-200);
    }
`;
